import { JsonSerializable } from '@/util/object/JsonSerializable'

export class ElementCustomizationsResponse extends JsonSerializable {
  /** @type {Object} */
  #attributes
  // known keys for attributes object
  // src
  /** @type {Object} */
  #css
  // known keys for css object
  // background-color
  // color
  /** @type {string} */
  #selector
  // known values for selector including double-quotes
  // "#svp-body"
  // "#svp-head img.company-logo"

  constructor (jsonObject) {
    super()
    this.#attributes = jsonObject.attributes || {}
    this.#css = jsonObject.css || {}
    this.#selector = jsonObject.selector
    Object.freeze(this)
  }

  get attributes () {
    return this.#attributes
  }

  get css () {
    return this.#css
  }

  get selector () {
    return this.#selector
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      attributes: this.#attributes,
      css: this.#css,
      selector: this.#selector
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {ElementCustomizationsResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new ElementCustomizationsResponse(jsonObject)) || undefined
  }
}
